var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26 0C11.66 0 0 11.66 0 26s11.66 26 26 26 26-11.66 26-26S40.34 0 26 0zm0 50C12.77 50 2 39.23 2 26S12.77 2 26 2s24 10.77 24 24-10.77 24-24 24z","key":0}),React.createElement("path",{"d":"M35.7 16.3a1 1 0 0 0-1.4 0L26 24.58l-8.3-8.3a1 1 0 1 0-1.4 1.42L24.58 26l-8.3 8.3a1 1 0 1 0 1.42 1.4L26 27.42l8.3 8.3a1 1 0 0 0 1.4 0 1 1 0 0 0 0-1.42L27.42 26l8.3-8.3a1 1 0 0 0 0-1.4z","key":1})]);
}

Icon.defaultProps = {"viewBox":"0 0 52 52"};

module.exports = Icon;

Icon.default = Icon;
